module.exports = __webpack_public_path__ + "static/media/60Pie.e7b6252f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/60Pie.png
// module id = 1681
// module chunks = 0 1